// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"aU-z","inlineTitle":"bU-z","sponsoredAdsWrapper":"cU-z","marketplaceRecosWrapper":"dU-z"};